import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, IconButton, Tooltip } from '@mui/material';

import styles from '../styles';

/* eslint-disable no-unused-vars */
type ApplicationNumberCellProps = {
  applicationNumber: string;
  onEdit: (applicationNumber: string) => void;
};
/* eslint-enable no-unused-vars */

const ApplicationNumberCell = ({ applicationNumber, onEdit }: ApplicationNumberCellProps) => (
  <Box sx={styles.applicationNumberCell}>
    <span>{applicationNumber}</span>
    {/* Edit navigates to the per-application comparison detail page. */}
    <Tooltip title='Edit'>
      <IconButton
        size='small'
        aria-label='edit application'
        onClick={event => {
          event.stopPropagation();
          onEdit(applicationNumber);
        }}>
        <EditOutlinedIcon fontSize='small' />
      </IconButton>
    </Tooltip>
  </Box>
);

export default ApplicationNumberCell;
